<template>
	<div v-loading="loadingView">
		<div
			v-if="showViewFlag"
			:style="{ height: showViewFlag ? '100%' : '0' }"
		>
			<router-view></router-view>
		</div>
		<div
			v-else
			class="noView"
			:style="{ height: showViewFlag ? '0' : '100%' }"
		>
			<topNavigation v-show="false"></topNavigation>
			<div class="noViewNav">
				<div class="noViewNavIcon">
					<a href="/">
						<img
							width="110"
							src="../../assets/imgs/public/logo_opcity_fff.png"
							alt=""
						/>
					</a>
				</div>
			</div>
			<div class="noViewContent">
				<div class="noViewContentBlock">
					<div class="authorityImg">
						<img
							src="../../assets/imgs/public/ideoauthority.png"
							alt=""
						/>
					</div>
					<div class="authorityBlock">
						<div
							v-if="
								viewMessage == '请登录' ||
								viewMessage == '您的登录已过期，请重新登陆！'
							"
							class="authorityMessage"
						>
							提示：<a
								:href="loginUrl"
								style="color: #0065cc"
								@click="login()"
							>
								{{ viewMessage }}</a
							>
						</div>
						<div v-else class="authorityMessage">
							提示：{{ viewMessage }}
						</div>
						<div class="authorityPhone">客服中心：4007070678</div>
						<div class="authorityEmail">
							信箱：
							<a :href="`mailto:service@drcnet.com.cn`">
								<span class="emailtext"
									>service@drcnet.com.cn</span
								>
							</a>
						</div>
						<!-- <div class="authorityButton" @click="back">
							返回首页
						</div> -->
						<a
							:href="loginUrl"
							class="authorityButton"
							@click="login()"
						>
							返回登录
						</a>
					</div>
				</div>
			</div>
			<div align="center" class="ideoFooter">
				Copyright © 1998-{{ new Date().getFullYear() }} DRCnet. All
				Rights Reserved版权所有 国研网
			</div>
		</div>
	</div>
</template>
<script>
import { getToken } from '@/utils/infomationStorage.js';
import { mapMutations, mapState } from 'vuex';
import topNavigation from '../topNavigation.vue';
export default {
	name: 'verifyAccess',
	components: { topNavigation },
	mixins: [],
	props: {},
	data() {
		return {
			showViewFlag: true, //权限
			viewMessage: '', //权限提示
			routerAlive: true,
			loginUrl: '',
			loadingView: true,
		};
	},
	computed: {
		...mapState(['userToken']),
		...mapState(['uid']),
	},

	watch: {
		uid: {
			handler(to) {
				this.getAccess(getToken());
			},
			// immediate: true, // ← 关键：组件挂载时立即触发
		},
		userToken: {
			handler(to) {
				this.getAccess(to);
			},
			// immediate: true, // ← 关键
		},
		$route: {
			handler(oldUid, newUid) {},
			immediate: true,
		},
	},
	created() {},
	destroyed() {},
	mounted() {
		// 兜底：8 秒后无论什么情况都关闭 loading
		// 防止 ajax 挂起、token 校验分支漏关 loading 等异常情况导致白屏
		// setTimeout(() => {
		// 	if (this.loadingView) {
		// 		console.warn('[ideologicalAccess] loading 兜底关闭（8s 超时）');
		// 		this.loadingView = false;
		// 	}
		// }, 8000);
	},
	methods: {
		getAccess(token) {
			let _this = this;
			this.loadingView = true;
			if (this.$route.name == 'custom') {
				_this.loadingView = false;
			}
			// if (window.location.pathname !== '/test/') {
			//部署成/test/目录下
			// if (window.location.pathname !== '/') {
			if (!getToken() || token == 'notoken') {
				// this.login();
				// window.location.href = this.loginUrl;
				// this.showViewFlag = false;
				// this.viewMessage = '请登录';
				_this.loadingView = false;
			} else {
				_this.loadingView = false;
				// _this.showViewFlag = false;
				// $.ajax({
				// 	url: `${
				// 		process.env.VUE_APP_BASE_IDEOLIOGICAL_API
				// 	}/reportapi/PolicyDocCommonController/checkUserPermUrl?token=${getToken()}&productId=3110`,
				// 	//查询用户是否有权限
				// 	dataType: 'json',
				// 	timeout: 5000, // 设置超时时间为5秒
				// 	// jsonpCallback: 'showData', //指定回调函数名称
				// 	// xhrFields: { withCredentials: true },
				// 	crossDomain: true,
				// 	async: true,
				// 	success: function (data) {
				// 		//code -1是未登录
				// 		//0是登录有权限
				// 		//-2是没权限
				// 		// console.log(_this.$router.history.current);
				// 		let descCode = data.code;
				// 		if (descCode == 0 || descCode == '0') {
				// 			_this.showViewFlag = true;
				// 			_this.loadingView = false;
				// 		} else {
				// 			//因为后端也不知道登录超时的状态  所以直接字符串写死了
				// 			if (
				// 				_this.viewMessage ==
				// 				'您的登录已过期，请重新登陆！'
				// 			) {
				// 				this.login();
				// 				window.location.href = this.loginUrl;
				// 			} else {
				// 				_this.showViewFlag = false;
				// 				_this.viewMessage = data.message;
				// 				_this.loadingView = false;
				// 			}
				// 		}
				// 	},
				// 	error: function (xhr, status, error) {
				// 		// that.docsData.title = '文章不存在!';
				// 		// 请求失败后的回调函数
				// 		console.log(status, error);
				// 		// 兜底：网络/超时失败时也要关掉遮罩、降级为可浏览，避免远程访问时遮罩永远卡住
				// 		_this.loadingView = false;
				// 		// _this.showViewFlag = true;
				// 	},
				// });
			}

			return;

			// let projectName = process.argv.slice(0)[3].replace('--', '');
			// console.log(process.env.PROJECT_ADDRESS);
		},
		//设置登录连接
		login() {
			let url = 'https://user.drcnet.com.cn/#/login';
			this.loginUrl =
				url +
				'?gourl=' +
				window.location.href.replace('?', '~~').replace('&', '^');
		},
		back() {
			//直接回到主页
			window.location.href = '/';
			// 获取历史记录中的页面数量
			// const historyLength = window.history.length;
		},
	},
};
</script>
<style lang="less" scoped>
.noView {
	background: #eff1f3;
	height: 1vh;
	width: 100%;
	position: absolute;
	.noViewNav {
		width: 100%;
		height: 70px;
		background: #c30000;
		border: none;
		display: flex;
		justify-content: center;
		align-items: center;
		.noViewNavIcon {
			width: 1200px;
			text-align: left;
			img {
				cursor: pointer;
			}
		}
	}
	.noViewContent {
		display: flex;
		justify-content: center;
		.noViewContentBlock {
			text-align: center;
			margin: 37px 47px 0 47px;
			margin-bottom: 0;
			width: 100%;
			height: 100%;
			background: #ffffff;
			box-shadow: 0px 5px 49px 0px rgba(239, 241, 243, 0.75);
			border-radius: 5px;
			display: flex;
			padding: 146px 0px 200px 351px;
			// align-items: center;
			text-align: left;
			.authorityImg {
				// margin-top: 60px;
				margin-right: 50px;
			}
			.authorityBlock {
				padding-top: 115px;
			}
			.authorityMessage {
				font-family: Microsoft YaHei;
				font-weight: 600;
				font-size: 30px;
				color: #333333;
				line-height: 48px;
			}
			.authorityPhone {
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 18px;
				color: #333333;
				line-height: 36px;
			}
			.authorityEmail {
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 18px;
				color: #333333;
				line-height: 36px;
				.emailtext {
					color: #0065cc;
				}
			}
			.authorityButton {
				width: 151px;
				height: 37px;
				text-align: center;
				margin-top: 20px;
				background: #f04243;
				border-radius: 19px;
				display: inline-block;
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 18px;
				color: #ffffff;
				line-height: 37px;
				cursor: pointer;
			}
		}
	}
	.ideoFooter {
		margin-top: 30px;
		color: #9c9c9c;
		font-size: 14px;
	}
}
</style>
